import developmentConfig from './development';
import stagingConfig from './staging';
import productionConfig from './production';

const getConfig = (environment = 'development') => {
  switch (environment) {
    case 'production':
      return productionConfig;
    case 'staging':
      return stagingConfig;
    case 'development':
    default:
      return developmentConfig;
  }
};

console.log('Current Environment:', process.env.REACT_APP_ENV);
const config = getConfig(process.env.REACT_APP_ENV);

export default config;
